var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7467 5.63329C13.0467 2.55329 10.3601 1.16663 8.00006 1.16663C8.00006 1.16663 8.00006 1.16663 7.9934 1.16663C5.64006 1.16663 2.94673 2.54663 2.24673 5.62663C1.46673 9.06663 3.5734 11.98 5.48006 13.8133C6.18673 14.4933 7.0934 14.8333 8.00006 14.8333C8.90673 14.8333 9.8134 14.4933 10.5134 13.8133C12.4201 11.98 14.5267 9.07329 13.7467 5.63329ZM8.00006 8.97329C6.84006 8.97329 5.90006 8.03329 5.90006 6.87329C5.90006 5.71329 6.84006 4.77329 8.00006 4.77329C9.16006 4.77329 10.1001 5.71329 10.1001 6.87329C10.1001 8.03329 9.16006 8.97329 8.00006 8.97329Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilled);
export default __webpack_public_path__ + "static/media/LocationFilled.1baeaff893cec5bc507de2e573b1b6d0.svg";
export { ForwardRef as ReactComponent };